module.exports = __webpack_public_path__ + "static/media/Асхобов С..cbb64edd.pdf";